export const rootPath = process.env.REACT_APP_ROOT_PATH || '/'
export const apiPath = process.env.REACT_APP_API_PATH || 'http://localhost:3001/'
